/**
 * useAdminMode — global, persisted Admin-mode flag (redesign item 2).
 * Default OFF. Only meaningful for admin users: every admin surface is
 * additionally gated on isAdmin, so a stale flag can never leak editorial
 * UI to non-admins. External store keeps AppNav + pages in sync.
 */
import { useSyncExternalStore, useCallback } from "react";

const KEY = "ti_admin_mode";
const listeners = new Set();
let current = (() => {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
})();

function subscribe(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useAdminMode() {
  const value = useSyncExternalStore(subscribe, () => current);
  const set = useCallback((v) => {
    current = typeof v === "function" ? v(current) : v;
    try { localStorage.setItem(KEY, current ? "1" : "0"); } catch {}
    listeners.forEach((cb) => cb());
  }, []);
  return [value, set];
}
